/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FavoriteHotelMutationResponse
 */
export interface FavoriteHotelMutationResponse {
    /**
     * 
     * @type {number}
     * @memberof FavoriteHotelMutationResponse
     */
    propertyId: number;
    /**
     * 
     * @type {boolean}
     * @memberof FavoriteHotelMutationResponse
     */
    isFavorite: boolean;
}

/**
 * Check if a given object implements the FavoriteHotelMutationResponse interface.
 */
export function instanceOfFavoriteHotelMutationResponse(value: object): value is FavoriteHotelMutationResponse {
    if (!('propertyId' in value) || value['propertyId'] === undefined) return false;
    if (!('isFavorite' in value) || value['isFavorite'] === undefined) return false;
    return true;
}

export function FavoriteHotelMutationResponseFromJSON(json: any): FavoriteHotelMutationResponse {
    return FavoriteHotelMutationResponseFromJSONTyped(json, false);
}

export function FavoriteHotelMutationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FavoriteHotelMutationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'propertyId': json['property_id'],
        'isFavorite': json['is_favorite'],
    };
}

export function FavoriteHotelMutationResponseToJSON(json: any): FavoriteHotelMutationResponse {
    return FavoriteHotelMutationResponseToJSONTyped(json, false);
}

export function FavoriteHotelMutationResponseToJSONTyped(value?: FavoriteHotelMutationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'property_id': value['propertyId'],
        'is_favorite': value['isFavorite'],
    };
}

